export const mediums = {
  FILM: "film",
  BOOK: "book",
  PODCAST: "podcast",
  ALBUM: "album",
  TV_SHOW: "tvShow",
};

/* *********************
 * Server defined values
 ***********************/

export const reportableContentTypes = {
  USER: "user",
  REVIEW: "review",
  COMMENT: "comment",
};

const commonReportReasons = ["other"];
export const freeTextReportReasons = ["spoilers", "offensive language"].concat(commonReportReasons);
export const userReportReasons = ["profile picture"].concat(commonReportReasons);
